import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarried = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "User_Profile.14",
	"data-name": "User,Profile.14",
	xmlns: "http://www.w3.org/2000/svg",
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_661",
		"data-name": "Group 661",
		transform: "translate(4.167 10.417)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2341",
				"data-name": "Path 2341",
				d: "M14.03,6.678a5.729,5.729,0,1,1-8.1,0,5.729,5.729,0,0,1,8.1,0",
				transform: "translate(0.437 -5)",
				fill: "none",
				stroke: "#323232",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2342",
				"data-name": "Path 2342",
				d: "M24.03,6.678a5.729,5.729,0,1,1-8.1,0,5.729,5.729,0,0,1,8.1,0",
				transform: "translate(11.271 -5)",
				fill: "none",
				stroke: "#323232",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2343",
				"data-name": "Path 2343",
				d: "M43.667,24.417a10.417,10.417,0,1,0-20.833,0A10.417,10.417,0,0,0,2,24.417",
				transform: "translate(-2 4.75)",
				fill: "none",
				stroke: "#323232",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2.5
			})
		]
	})
});
export default SvgMarried;
